import { render } from "./LanguageTab.vue?vue&type=template&id=565a10c8"
import script from "./LanguageTab.vue?vue&type=script&lang=js"
export * from "./LanguageTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__